import React from 'react';
import axios from '../../../axios.config';

type data = {
    loading: boolean;
    errorMessage: string;

};

type handlers = {
    getUsersGroups: (accessToken: string) => Promise<any>;

};

export function useUsersGroups(): [data, handlers] {
    const [errorMessage, setErrorMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const getUsersGroups = async (accessToken: string) => {
        setLoading(true);
        setErrorMessage('');

        try {

            const response = await axios.get(
                '/userApps_func',
                {
                    params: { action: 'get_user_groups' },
                    headers: { Authorization: `Bearer ${accessToken}`, }
                }
            );
            console.log('Get Users Group ', response.data)
            return response.data;
        } catch (error: any) {
            const errorMessage = error.response?.data.response_code || 'CHAM-ERROR-000';
            setErrorMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return [

        { loading, errorMessage },
        { getUsersGroups }

    ];
}
